import { useQuery } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../api/ApiRoutes";

/** First segment of `queryKey`; use with `queryClient.invalidateQueries`. */
export const GET_IN_PROGRESS_TRANSACTIONS_QUERY_KEY =
  "GET_IN_PROGRESS_TRANSACTIONS";

/**
 * POST /admin-panel-payments/v1/withdrawals/in-progress-transactions
 * Same payload contract as pending/processed withdrawal lists.
 */
export async function fetchInProgressTransactions({
  start_date,
  end_date,
  page_size,
  page,
  last_evaluated_key,
  total_count,
  subregion,
  method,
}) {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
  );

  const payload = {
    page_size,
    page,
    start_date,
    end_date,
    last_evaluated_key,
    ...(subregion && { subregion }),
    ...(method && { method }),
  };

  if (page === 1) {
    payload.last_evaluated_key = null;
  }

  if (typeof total_count === "number") {
    payload.total_count = total_count;
  }

  const response = await PrivateAdminPanelInstance.post(
    API_ROUTES.GET_IN_PROGRESS_TRANSACTIONS,
    payload,
  );

  return (
    response?.data?.data ?? {
      transactions: [],
      pagination: { page, page_size, total_results: 0 },
    }
  );
}

export const useGetInProgressTransactions = (
  start_date,
  end_date,
  page_size,
  page,
  last_evaluated_key,
  total_count,
  subregion = null,
  method = null,
) => {
  return useQuery({
    queryKey: [
      GET_IN_PROGRESS_TRANSACTIONS_QUERY_KEY,
      start_date,
      end_date,
      page_size,
      page,
      subregion,
      method,
    ],
    queryFn: () =>
      fetchInProgressTransactions({
        start_date,
        end_date,
        page_size,
        page,
        last_evaluated_key,
        total_count,
        subregion,
        method,
      }),
    keepPreviousData: true,
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};
